import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

const XpoTile = (props) => {
  const {
    buttonIcon,
    buttonLink,
    buttonPosition,
    buttonColor,
    title,
    subtitle,
    bgUrl,
  } = props;

  return (
    <div className={`tile ${buttonPosition}`} style={{ borderColor: buttonColor }} >
      <div className="bg" style={{ backgroundImage: `url(${bgUrl})` }} />
      <Link to={buttonLink} className="tile-holder" style={{ color: buttonColor }}>
        {(buttonPosition === 'training' || buttonPosition === 'prize') &&
          <div className="arrow">
            <FontAwesomeIcon icon={['fas', 'chevron-right']} />
          </div>
        }
        {(buttonPosition === 'breakout' || buttonPosition === 'network') &&
          <div className="arrow left">
            <FontAwesomeIcon icon={['fas', 'chevron-left']} />
          </div>
        }
        {(buttonPosition === 'exhibition') &&
          <React.Fragment>
            <div className="arrow">
              <FontAwesomeIcon icon={['fas', 'chevron-left']} />
            </div>
            <div className="arrow left">
              <FontAwesomeIcon icon={['fas', 'chevron-right']} />
            </div>
          </React.Fragment>
        }
        <div className="icon">
          <FontAwesomeIcon icon={['far', buttonIcon]} />
        </div>
        <div className="title">
          {title}
        </div>
        <div className="line" style={{ backgroundColor: buttonColor, borderColor: buttonColor }} />
        <div className="sub_title">
          {subtitle}
        </div>
      </Link>
    </div>
  );
};

XpoTile.propTypes = {
  buttonIcon: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonPosition: PropTypes.string,
  buttonColor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  bgUrl: PropTypes.string,
};

XpoTile.defaultProps = {
  buttonIcon: '',
  buttonLink: '',
  buttonPosition: '',
  buttonColor: '',
  title: '',
  subtitle: '',
  bgUrl: '',
};

export default XpoTile;
